'use strict'

export default function (): void {
  document.getElementById('dashboard-form')?.addEventListener('submit', function () {
    document.getElementById('bookings-loading')?.classList.add('loading--visible')

    const listEl = document.getElementById('bookings-list')

    if (listEl) {
      listEl.classList.add('list--hidden')
    }
  })
}
